import type { Tenant } from '@/types';

/** Demo tenant. In production this comes from the tenant-resolution layer + API. */
export const demoTenant: Tenant = {
  id: 'tenant_demo',
  slug: 'demo',
  name: 'Demo Commerce Store',
  tagline: 'Premium quality for a better tomorrow',
  currency: 'INR',
  contact: {
    email: 'support@demo-commerce.store',
    phone: '+91 98765 43210',
    address: '14, Residency Road, Bengaluru, Karnataka 560025',
  },
  social: { instagram: '#', facebook: '#', x: '#', youtube: '#' },
  announcement: 'Free shipping on orders above ₹999 · Use code WELCOME10 for 10% off your first order',
  theme: {
    primaryColor: '#5b5bf0',
    secondaryColor: '#141a4a',
    accentColor: '#ff7a3d',
    fontFamily: 'Inter',
    borderRadius: '0.75rem',
  },
  features: {
    products: true,
    categories: true,
    cart: true,
    orders: true,
    payments: true,
    wallet: true,
    loyalty: true,
    coupons: true,
    banners: true,
    reviews: true,
    referrals: false,
    affiliate: true,
    campaigns: true,
    analytics: true,
  },
  shipping: { freeThreshold: 999, flatFee: 79 },
  taxRate: 18,
  seo: {
    title: 'Demo Commerce Store — Premium electronics, fashion & lifestyle',
    description: 'Shop curated electronics, fashion, home and lifestyle products with fast delivery, wallet cashback and loyalty rewards.',
  },
  loyalty: { pointsPer100: 1, pointValue: 1, minRedeem: 50 },
};
